import { render, staticRenderFns } from "./WorkForm.vue?vue&type=template&id=87138a5e&scoped=true"
import script from "./WorkForm.vue?vue&type=script&lang=js"
export * from "./WorkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87138a5e",
  null
  
)

export default component.exports